import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18next
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    ns: ["common", "profile", "tournaments"],
    defaultNS: "common",
    fallbackNS: "common",
    fallbackLng: "en-US",
    supportedLngs: ["en-US", "fr-FR"],
    interpolation: {
      escapeValue: false,
    },
    parseMissingKeyHandler: (key: string) => {
      return `💥No translation for "${key}"💥`;
    },
  });

export default i18next;
